import {useCallback, useEffect, useRef, useState} from 'react'
import {FixedSizeList} from 'react-window'
import {useSlctMenuOpen} from 'module/Slct/hook/useSlctMenuOpen'
import {useSlctByValue} from 'module/Slct/hook/useSlctByValue'
import {SlctBaseProps} from 'module/Slct/type/SlctType'

export function useSlctProps<ModelType extends object | void, ValueType extends string | number>(props: SlctBaseProps<ModelType, ValueType>) {
	let {
		byValueCache,
		options: optionsUnfiltered,
		menuIsOpen: menuOpenExternal, setMenuIsOpen: setMenuOpenExternal,
		memo,
		refInput: refInputExternal,
		disabled,
	} = props
	const ref = useRef<HTMLDivElement | null>(null)
	const refInput = useRef<HTMLInputElement | null>(null)
	const setRefInput = useCallback((el: HTMLInputElement | null) => {
		refInput.current = el
		if (refInputExternal) refInputExternal.current = el
	}, [refInput, refInputExternal])
	const refMenu = useRef<HTMLDivElement | null>(null)
	const refList = useRef<FixedSizeList | null>(null)
	const [inputValue, setInputValue] = useState('')
	let [cursor, setCursor] = useState<number | null>(null)
	let [focus, setFocus] = useState(false)
	let {menuOpen, setMenuOpen, hasMenu} = useSlctMenuOpen(menuOpenExternal, setMenuOpenExternal)
	const byValue = useSlctByValue({byValueCache, optionsUnfiltered})
	const {memoKey, memoSize, memoAutoAdd} = memo || {}

	useEffect(() => {
		if (disabled) {
			if (focus) setFocus(false)
			if (menuOpen) setMenuOpen(false)
			if (cursor) setCursor(null)
		}
	}, [disabled, focus, menuOpen, cursor, setFocus, setMenuOpen, setCursor])

	if (disabled) {
		cursor = null
		focus = false
		menuOpen = false
	}

	return {
		byValue,
		inputValue, setInputValue,
		cursor, setCursor,
		focus, setFocus,
		menuOpen, setMenuOpen,
		memoKey, memoSize, memoAutoAdd,
		hasMenu,
		ref,
		refInput, setRefInput,
		refMenu,
		refList,
	}
}